import type { EscalationStage } from "@remi/enums/escalation-stage";

const BACKWARD_TRANSITIONS: [EscalationStage, EscalationStage][] = [
  ["PENDING_CONTACT", "NOT_CONTACTED"],
  ["PENDING_RESOLUTION", "NOT_CONTACTED"],
  ["RESOLVED_PENDING_COMPLETION", "PENDING_RESOLUTION"],
  ["RESOLVED_PENDING_COMPLETION", "NOT_CONTACTED"],
  ["COMPLETION", "PENDING_RESOLUTION"],
  ["DISMISSED", "PENDING_RESOLUTION"],
];

export function isBackwardTransition(from: EscalationStage, to: EscalationStage): boolean {
  return BACKWARD_TRANSITIONS.some(([f, t]) => f === from && t === to);
}

export function isTerminalStage(stage: EscalationStage): boolean {
  return stage === "COMPLETION" || stage === "DISMISSED";
}
